import { ElementWithSettings } from "../ElementWithSettings";
import { hasSetting } from "./settingUtilities";

const RESPONSE_QUALITY_SETTINGS_KEY = "RESPONSE_QUALITY_SETTINGS";

/** PastedText section from RESPONSE_QUALITY_SETTINGS JSON. */
export interface PastedTextConfig {
    QuestionIds: number[];
    Enabled: boolean;
    Action: number;
}

/** Full response quality settings (subset we care about). */
export interface ResponseQualitySettings {
    PastedText?: PastedTextConfig;
}

/**
 * Parses RESPONSE_QUALITY_SETTINGS from questionnaire settings (JSON string).
 * Returns the parsed object or null if missing/invalid.
 */
export function getResponseQualitySettings(
    questionnaire: ElementWithSettings,
): ResponseQualitySettings | null {
    if (!questionnaire?.settings || !hasSetting(questionnaire, RESPONSE_QUALITY_SETTINGS_KEY)) {
        return null;
    }
    const raw = questionnaire.settings[RESPONSE_QUALITY_SETTINGS_KEY];
    if (typeof raw !== "string") return null;
    try {
        return JSON.parse(raw) as ResponseQualitySettings;
    } catch {
        return null;
    }
}

/**
 * Returns PastedText config from RESPONSE_QUALITY_SETTINGS when present and valid.
 */
export function getPastedTextConfig(
    questionnaire: ElementWithSettings,
): PastedTextConfig | null {
    const settings = getResponseQualitySettings(questionnaire);
    const pasted = settings?.PastedText;
    if (!pasted || !Array.isArray(pasted.QuestionIds)) return null;
    return pasted;
}
